// Mock data para Eclipse Tenis

export const productos = [
  // Zapatillas Hombre - Tendencias
  {
    id: 1,
    nombre: "Air Force Classic White",
    precio: 289900,
    precioOferta: null,
    marca: "Nike",
    categoria: "Hombre",
    subcategoria: "Tendencias",
    imagen: "https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a",
    imagenes: [
      "https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a",
      "https://images.unsplash.com/photo-1600269452121-4f2416e55c28",
      "https://images.unsplash.com/photo-1608667508764-33cf0726b13a"
    ],
    sku: "AFW-001",
    stock: 9,
    colores: ["Blanco", "Negro", "Gris"],
    tallas: ["38", "39", "40", "41", "42", "43"],
    descripcion: "Las clásicas Air Force en color blanco. Perfectas para cualquier ocasión, combinan estilo y comodidad en un diseño atemporal.",
    rating: 4.8,
    reviews: 45,
    tags: ["tendencia", "casual", "deporte"],
    oferta: false
  },
  {
    id: 2,
    nombre: "Air Jordan 1 Retro",
    precio: 459900,
    precioOferta: null,
    marca: "Nike",
    categoria: "Hombre",
    subcategoria: "Clásicas",
    imagen: "https://images.unsplash.com/photo-1552346154-21d32810aba3",
    imagenes: [
      "https://images.unsplash.com/photo-1552346154-21d32810aba3",
      "https://images.unsplash.com/photo-1542291026-7eec264c27ff"
    ],
    sku: "AJ1-002",
    stock: 5,
    colores: ["Rojo", "Blanco", "Negro"],
    tallas: ["38", "39", "40", "41", "42", "43", "44"],
    descripcion: "Las icónicas Air Jordan 1. Un clásico que nunca pasa de moda, ideal para amantes del streetwear y el estilo urbano.",
    rating: 4.9,
    reviews: 78,
    tags: ["clásica", "jordan", "urbano"],
    oferta: false
  },
  {
    id: 3,
    nombre: "Nike Running Pro",
    precio: 329900,
    precioOferta: 249900,
    marca: "Nike",
    categoria: "Hombre",
    subcategoria: "Correr y entrenar",
    imagen: "https://images.unsplash.com/photo-1562183241-b937e95585b6",
    imagenes: [
      "https://images.unsplash.com/photo-1562183241-b937e95585b6",
      "https://images.unsplash.com/photo-1597892657493-6847b9640bac"
    ],
    sku: "NRP-003",
    stock: 12,
    colores: ["Gris", "Negro", "Azul"],
    tallas: ["38", "39", "40", "41", "42", "43", "44"],
    descripcion: "Zapatillas diseñadas para el rendimiento. Tecnología de amortiguación avanzada para tus entrenamientos más exigentes.",
    rating: 4.7,
    reviews: 34,
    tags: ["running", "training", "deporte"],
    oferta: true
  },
  {
    id: 4,
    nombre: "Botas Impermeables Outdoor",
    precio: 389900,
    precioOferta: null,
    marca: "Columbia",
    categoria: "Hombre",
    subcategoria: "Botas impermeables",
    imagen: "https://images.unsplash.com/photo-1550998358-08b4f83dc345",
    imagenes: [
      "https://images.unsplash.com/photo-1550998358-08b4f83dc345",
      "https://images.unsplash.com/photo-1608256246200-53e635b5b65f",
      "https://images.pexels.com/photos/167706/pexels-photo-167706.jpeg"
    ],
    sku: "BOT-004",
    stock: 7,
    colores: ["Marrón", "Negro"],
    tallas: ["39", "40", "41", "42", "43", "44"],
    descripcion: "Botas impermeables perfectas para aventuras al aire libre. Material resistente y suela antideslizante.",
    rating: 4.6,
    reviews: 23,
    tags: ["outdoor", "impermeables", "aventura"],
    oferta: false
  },
  // Zapatillas Mujer
  {
    id: 5,
    nombre: "Puma White Classic",
    precio: 259900,
    precioOferta: null,
    marca: "Puma",
    categoria: "Mujer",
    subcategoria: "Tendencias",
    imagen: "https://images.unsplash.com/photo-1608231387042-66d1773070a5",
    imagenes: [
      "https://images.unsplash.com/photo-1608231387042-66d1773070a5",
      "https://images.pexels.com/photos/1598505/pexels-photo-1598505.jpeg"
    ],
    sku: "PWC-005",
    stock: 15,
    colores: ["Blanco", "Rosa", "Negro"],
    tallas: ["35", "36", "37", "38", "39", "40"],
    descripcion: "Zapatillas clásicas Puma para mujer. Estilo minimalista y elegante para el día a día.",
    rating: 4.5,
    reviews: 56,
    tags: ["tendencia", "casual", "mujer"],
    oferta: false
  },
  {
    id: 6,
    nombre: "Zapatillas Training Mujer",
    precio: 279900,
    precioOferta: 199900,
    marca: "Adidas",
    categoria: "Mujer",
    subcategoria: "Correr y entrenar",
    imagen: "https://images.pexels.com/photos/2529148/pexels-photo-2529148.jpeg",
    imagenes: [
      "https://images.pexels.com/photos/2529148/pexels-photo-2529148.jpeg",
      "https://images.pexels.com/photos/601177/pexels-photo-601177.jpeg"
    ],
    sku: "ATW-006",
    stock: 10,
    colores: ["Negro", "Gris", "Morado"],
    tallas: ["35", "36", "37", "38", "39", "40"],
    descripcion: "Zapatillas de entrenamiento con soporte óptimo. Perfectas para gym y actividades deportivas.",
    rating: 4.8,
    reviews: 41,
    tags: ["training", "gym", "mujer"],
    oferta: true
  },
  {
    id: 7,
    nombre: "Botas Impermeables Mujer",
    precio: 359900,
    precioOferta: null,
    marca: "Timberland",
    categoria: "Mujer",
    subcategoria: "Botas Impermeables",
    imagen: "https://images.pexels.com/photos/1123985/pexels-photo-1123985.jpeg",
    imagenes: [
      "https://images.pexels.com/photos/1123985/pexels-photo-1123985.jpeg",
      "https://images.unsplash.com/photo-1605812860427-4024433a70fd"
    ],
    sku: "BIM-007",
    stock: 6,
    colores: ["Marrón", "Negro"],
    tallas: ["35", "36", "37", "38", "39", "40"],
    descripcion: "Botas impermeables de alta calidad para mujer. Estilo y protección en cualquier clima.",
    rating: 4.7,
    reviews: 28,
    tags: ["outdoor", "impermeables", "mujer"],
    oferta: false
  },
  {
    id: 8,
    nombre: "Zapatillas Urbanas Lifestyle",
    precio: 239900,
    precioOferta: null,
    marca: "Vans",
    categoria: "Mujer",
    subcategoria: "Clásicas",
    imagen: "https://images.unsplash.com/photo-1554062614-6da4fa67725a",
    imagenes: [
      "https://images.unsplash.com/photo-1554062614-6da4fa67725a",
      "https://images.pexels.com/photos/318236/pexels-photo-318236.jpeg"
    ],
    sku: "VUL-008",
    stock: 20,
    colores: ["Negro", "Blanco", "Azul"],
    tallas: ["35", "36", "37", "38", "39", "40"],
    descripcion: "Zapatillas de estilo urbano para mujer. Perfectas para looks casuales y modernos.",
    rating: 4.6,
    reviews: 52,
    tags: ["urbano", "casual", "mujer"],
    oferta: false
  },
  // Más productos
  {
    id: 9,
    nombre: "Zapatillas Deportivas Pro",
    precio: 319900,
    precioOferta: null,
    marca: "Reebok",
    categoria: "Hombre",
    subcategoria: "Correr y entrenar",
    imagen: "https://images.pexels.com/photos/2529148/pexels-photo-2529148.jpeg",
    imagenes: [
      "https://images.pexels.com/photos/2529148/pexels-photo-2529148.jpeg"
    ],
    sku: "RDP-009",
    stock: 8,
    colores: ["Negro", "Rojo", "Blanco"],
    tallas: ["39", "40", "41", "42", "43"],
    descripcion: "Zapatillas deportivas de alto rendimiento. Diseño ergonómico y materiales de calidad premium.",
    rating: 4.5,
    reviews: 19,
    tags: ["deporte", "running", "training"],
    oferta: false
  },
  {
    id: 10,
    nombre: "Sneakers Casuales Urban",
    precio: 229900,
    precioOferta: 169900,
    marca: "New Balance",
    categoria: "Hombre",
    subcategoria: "Tendencias",
    imagen: "https://images.unsplash.com/photo-1608667508764-33cf0726b13a",
    imagenes: [
      "https://images.unsplash.com/photo-1608667508764-33cf0726b13a"
    ],
    sku: "NBU-010",
    stock: 14,
    colores: ["Gris", "Azul", "Negro"],
    tallas: ["38", "39", "40", "41", "42", "43"],
    descripcion: "Sneakers urbanos con estilo contemporáneo. Comodidad y diseño para tu día a día.",
    rating: 4.4,
    reviews: 31,
    tags: ["urbano", "casual", "tendencia"],
    oferta: true
  }
];

export const accesorios = [
  {
    id: 101,
    nombre: "Cordones Premium",
    precio: 19900,
    precioOferta: null,
    marca: "Eclipse Tenis",
    categoria: "Accesorios",
    subcategoria: "Cordones",
    imagen: "https://images.unsplash.com/photo-1722340321190-1c7b7384e89b",
    imagenes: ["https://images.unsplash.com/photo-1722340321190-1c7b7384e89b"],
    sku: "COR-101",
    stock: 50,
    colores: ["Blanco", "Negro", "Rojo", "Azul"],
    descripcion: "Cordones de alta calidad para tus zapatillas. Resistentes y duraderos.",
    rating: 4.3,
    reviews: 12,
    tags: ["accesorio", "cordones"],
    oferta: false
  },
  {
    id: 102,
    nombre: "Medias Deportivas Pack x3",
    precio: 29900,
    precioOferta: null,
    marca: "Eclipse Tenis",
    categoria: "Accesorios",
    subcategoria: "Medias",
    imagen: "https://images.unsplash.com/photo-1676312830459-f6f13dfdd899",
    imagenes: ["https://images.unsplash.com/photo-1676312830459-f6f13dfdd899"],
    sku: "MED-102",
    stock: 35,
    colores: ["Blanco", "Negro", "Gris"],
    descripcion: "Pack de 3 pares de medias deportivas. Material transpirable y cómodo.",
    rating: 4.6,
    reviews: 24,
    tags: ["accesorio", "medias"],
    oferta: false
  },
  {
    id: 103,
    nombre: "Kit de Limpieza Premium",
    precio: 49900,
    precioOferta: 39900,
    marca: "Eclipse Tenis",
    categoria: "Accesorios",
    subcategoria: "Kit de limpieza",
    imagen: "https://images.pexels.com/photos/17938771/pexels-photo-17938771.jpeg",
    imagenes: ["https://images.pexels.com/photos/17938771/pexels-photo-17938771.jpeg"],
    sku: "KIT-103",
    stock: 25,
    descripcion: "Kit completo para mantener tus zapatillas como nuevas. Incluye cepillo, solución limpiadora y paño.",
    rating: 4.8,
    reviews: 18,
    tags: ["accesorio", "limpieza"],
    oferta: true
  },
  {
    id: 104,
    nombre: "Protector de Zapatillas",
    precio: 34900,
    precioOferta: null,
    marca: "Eclipse Tenis",
    categoria: "Accesorios",
    subcategoria: "Protector de zapatillas",
    imagen: "https://images.unsplash.com/photo-1722340321190-1c7b7384e89b",
    imagenes: ["https://images.unsplash.com/photo-1722340321190-1c7b7384e89b"],
    sku: "PRO-104",
    stock: 30,
    descripcion: "Spray protector contra agua y manchas. Mantiene tus zapatillas protegidas por más tiempo.",
    rating: 4.5,
    reviews: 15,
    tags: ["accesorio", "protector"],
    oferta: false
  }
];

export const todosLosProductos = [...productos, ...accesorios];

const PUBLIC_ASSET_BASE = process.env.PUBLIC_URL || "";

export const banners = [
  {
    id: 1,
    titulo: "Nuevos Modelos 2026",
    subtitulo: "Descubre las últimas tendencias en zapatillas",
    cta: "Ver Modelos",
    link: "/catalogo/hombre",
    imagen: "https://images.unsplash.com/photo-1585944672394-4c58a015c1fb"
  },
  {
    id: 2,
    titulo: "WhatsApp para dudas y novedades",
    subtitulo: "Atencion inmediata sobre compras y pagos con Sistecredito",
    cta: "Hablar por WhatsApp",
    link: "https://wa.me/573184215616?text=Hola%20estoy%20interesado%20en%20un%20producto",
    imagen: `${PUBLIC_ASSET_BASE}/whatsaap.jpg`
  },
  {
    id: 3,
    titulo: "Correr y entrenar",
    subtitulo: "Máximo rendimiento para tus entrenamientos",
    cta: "Ver Colección",
    link: "/catalogo/hombre",
    imagen: "https://images.pexels.com/photos/7432/pexels-photo.jpg"
  },
  {
    id: 4,
    enabled: false,
    titulo: "Compra a credito Sistecredito",
    subtitulo: "Proceso rapido y seguro para pagar a cuotas",
    cta: "Ir al checkout",
    link: "/checkout",
    imagen: `${PUBLIC_ASSET_BASE}/Sistecredito.png`,
    fallbackImage: `${PUBLIC_ASSET_BASE}/Sistecredito.jpg`,
    steps: [
      "Agrega tus productos al carrito.",
      "En el pago, elige Sistecredito.",
      "Ingresa documento, celular y correo.",
      "Selecciona cuotas y acepta terminos.",
      "Confirma con codigo por WhatsApp.",
      "Despacho en 24 a 48 horas."
    ]
  },
];

export const categorias = [
  {
    nombre: "Hombre",
    slug: "hombre",
    imagen: `${PUBLIC_ASSET_BASE}/hombre.jpg`,
    subcategorias: ["Tendencias", "Clásicas", "Correr y entrenar", "Botas impermeables"]
  },
  {
    nombre: "Mujer",
    slug: "mujer",
    imagen: `${PUBLIC_ASSET_BASE}/mujer.jpg`,
    subcategorias: ["Tendencias", "Clásicas", "Correr y entrenar", "Botas Impermeables"]
  },
  {
    nombre: "Accesorios",
    slug: "accesorios",
    imagen: `${PUBLIC_ASSET_BASE}/accesorios.jpg`,
    subcategorias: ["Cordones", "Medias", "Kit de limpieza", "Protector de zapatillas"]
  }
];

export const marcas = [
  "Nike",
  "Adidas",
  "Puma",
  "Reebok",
  "New Balance",
  "Vans",
  "Columbia",
  "Timberland",
  "Eclipse Tenis"
];

export const reviews = [
  {
    id: 1,
    productoId: 1,
    nombre: "Carlos Martínez",
    rating: 5,
    comentario: "Excelente calidad y llegaron súper rápido a Bogotá. Las zapatillas son tal cual las fotos.",
    fecha: "2025-01-15"
  },
  {
    id: 2,
    productoId: 1,
    nombre: "María López",
    rating: 5,
    comentario: "Me encantan! Muy cómodas y el precio es excelente. Recomendado 100%.",
    fecha: "2025-01-10"
  },
  {
    id: 3,
    productoId: 2,
    nombre: "Andrés Gómez",
    rating: 5,
    comentario: "Las Jordan son originales y de muy buena calidad. Valió la pena la espera.",
    fecha: "2025-01-12"
  }
];
